import { render, staticRenderFns } from "./trainProgram.vue?vue&type=template&id=123f02f6"
import script from "./trainProgram.vue?vue&type=script&lang=js"
export * from "./trainProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports